import Icon from '../components/Icon.vue'

Icon.register({"coffee":{"width":1920,"height":1792,"paths":[{"d":"M1664 640q0-80-56-136t-136-56h-64v384h64q80 0 136-56t56-136zM0 1408h1792q0 106-75 181t-181 75h-1280q-106 0-181-75t-75-181zM1856 640q0 159-112.5 271.5t-271.5 112.5h-64v32q0 92-66 158t-158 66h-704q-92 0-158-66t-66-158v-736q0-26 19-45t45-19h1152q159 0 271.5 112.5t112.5 271.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/coffee.js
// module id = 984
// module chunks = 0